import { ClbLayout, ClbLayoutContent, ClbLayoutHeader, ClbLayoutSider } from '@celebration/react'
import { FC } from 'react'
import { Outlet } from 'react-router-dom'
import Header from './Header'
import SideMenu from './SideMenu'

const Layout: FC = (): React.ReactElement => (
  <ClbLayout>
    <ClbLayoutHeader>
      <Header />
    </ClbLayoutHeader>
    <ClbLayoutSider>
      <SideMenu />
    </ClbLayoutSider>
    <ClbLayoutContent>
      <Outlet />
    </ClbLayoutContent>
  </ClbLayout>
)

export default Layout
